<script lang="ts">
  import handleClickOutside from '../../utils/handle-click-outside';
  import a11yClick from '../../utils/a11y-click';

  export let position: 'top' | 'right' | 'bottom' | 'left';
  export let openOnClick = false;
  export let openOnHover = false;

  let open = false;
  let triggerElement: HTMLDivElement;

  $: getTooltipPositionStyle = (): string => {
    const elementRect = triggerElement?.getBoundingClientRect();

    if (!elementRect) {
      return '';
    }

    let top = 'auto';
    let right = 'auto';
    let bottom = 'auto';
    let left = 'auto';
    let translateX = '0';
    let translateY = '0';

    switch (position) {
      case 'top':
        bottom = '100%';
        left = '50%';
        translateX = '-50%';
        break;
      case 'right':
        top = '50%';
        left = '100%';
        translateY = '-50%';
        break;
      case 'bottom':
        top = '100%';
        left = '50%';
        translateX = '-50%';
        break;
      case 'left':
        top = '50%';
        right = '100%';
        translateY = '-50%';
        break;
    }

    return `top: ${top}; right: ${right}; bottom: ${bottom}; left:${left}; transform: translate(${translateX}, ${translateY});`;
  };
</script>

<style lang="postcss">
  .wrapper {
    position: relative;
    display: inline-flex;
  }

  .wrapper:focus-visible {
    outline: none;
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  .trigger,
  .trigger :global([slot='trigger']) {
    display: inline-flex;
  }

  .trigger.open :global([slot='trigger'] > *) {
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  .tooltipContainer {
    z-index: var(--ubilabs-portal-z-index);
    position: absolute;
    pointer-events: none;
  }

  .tooltip {
    display: inline-block;
    width: 20rem;
    max-width: calc(100vw - 4rem);
    margin: var(--ubilabs-tooltip-margin);
    padding: var(--ubilabs-tooltip-padding);
    background-color: var(--ubilabs-tooltip-background-color);
    box-shadow: var(--ubilabs-tooltip-box-shadow);
    border-radius: var(--ubilabs-tooltip-border-radius);
    font-size: var(--ubilabs-tooltip-font-size);
  }
</style>

<div
  class="wrapper {$$props.class}"
  on:mouseenter={() => {
    if (openOnHover) {
      open = true;
    }
  }}
  on:mouseleave={() => {
    if (openOnHover) {
      open = false;
    }
  }}
  on:focus={() => {
    if (openOnHover) {
      open = true;
    }
  }}
  on:blur={() => {
    if (openOnHover) {
      open = false;
    }
  }}
  on:click={() => {
    if (openOnClick) {
      open = true;
    }
  }}
  on:keypress={event => {
    if (openOnClick && a11yClick(event)) {
      open = true;
    }
  }}
  tabIndex={0}>
  <div class="trigger {open ? 'open' : ''}" bind:this={triggerElement}>
    <slot name="trigger" />
  </div>

  {#if open}
    <div class="tooltipContainer" style={getTooltipPositionStyle()}>
      {#if openOnClick}
        <div
          class="tooltip {$$props.class}"
          use:handleClickOutside
          on:click_outside={() => {
            open = false;
          }}>
          <slot name="content" />
        </div>
      {:else}
        <div class="tooltip {$$props.class}">
          <slot name="content" />
        </div>
      {/if}
    </div>
  {/if}
</div>
